import React, { Component } from 'react'
// import { Route, Switch } from 'react-router-dom'
import { withTheme } from 'material-ui/styles'
// import _ from 'lodash'
// import flat from 'flat'

import core from '../../core'
import common from '../../common'

import { PATH, LABEL, NAME, FORM, subForms } from '../constants'
import {
  getEnrichedRegister
  // compactData,
  // updateHistory,
  // handlePersonAdd
} from '../helpers'

import * as configs from '../configs'

const {
  subFormsDispatcher,
  getConfig,
  commonConfigValues,
  getDataFunctions
} = configs

const {
  constants: { nationalities },
  helpers: { compactData, updateHistory, handlePersonAdd },
  components: { InnerRouter }
} = common

const {
  // components: { Auth, NoMatch },
  constants: { DATE_FORMAT }
} = core

class Container extends Component {
  render() {
    const propsToPass = {
      subFormsDispatcher,
      getData: getEnrichedRegister,
      helpers: {
        compactData,
        updateHistory,
        handlePersonAdd
      },
      constantProps: { PATH, LABEL, NAME, DATE_FORMAT, FORM }
    }

    const valueTable = { nationalities }

    return (
      <InnerRouter
        {...this.props}
        innerRouterInput={{
          commonConfigValues,
          valueTable,
          subForms,
          propsToPass,
          getConfig,
          getDataFunctions,
          listScreenData: [{ id: 35 }, { id: 44 }, { id: 45 }]
        }}
      />
    )
  }
}

export default withTheme()(Container)



// WEBPACK FOOTER //
// ./src/register/components/Container.js